import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { app } from '@microsoft/teams-js';
@Component({
    selector: 'app-root',
    encapsulation: ViewEncapsulation.None,
    template: `<router-outlet></router-outlet>`
})
export class RootComponent implements OnInit {

    readonly VAPID_PUBLIC_KEY = 'Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXlcdnRdQ2RdVUZ+W0tWYE0=';

    constructor(private swPush: SwPush) {

    }

    ngOnInit() {
        let isIframe = window !== window.parent && !window.opener;
        if (isIframe) {
            if (app.isInitialized()) {
                app.notifySuccess();
            }
        }
        this.swPush.notificationClicks.subscribe(
            ({ action, notification }) => {
                // TODO: Do something in response to notification click.
            });
    }

}
